export const defaultRoles = {
  participant: "participant",
  moderator: "moderator",
  moderatorAndParticipant: "moderatorAndParticipant",
  demo: "demo"
};

export const defaultPlatforms = {
  mt: "mt",
  mft: "mft",
  mtOnline: "mtOnline",
  mtDemo: "mtDemo",
  mtOnlineDemo: "mtOnlineDemo"
};

export const ALLOWED_SKILLS = 2;

export const VideoStatusDefaults = {
  paused: "paused",
  playing: "playing"
};

export const iconsMappingList = [
  ["magnifier", "head"],
  ["magnifier", "person"],
  ["radar", "head"],
  ["radar", "person"]
];

export const VideoById = {
  mt: {
    1: {
      en: "907650816",
      de: "907608533",
      fr: "912229209",
      it: "927420569"
    },
    2: {
      en: "907650844",
      de: "907608596",
      fr: "912229334",
      it: "927420625"
    },
    3: {
      en: "907650912",
      de: "907611331",
      fr: "912228197",
      it: "927420734"
    },
    4: {
      en: "907650944",
      de: "907611379",
      fr: "912228261",
      it: "927420790"
    },
    5: {
      en: "907651111",
      de: "907611283",
      fr: "912228691",
      it: "927420974"
    },
    6: {
      en: "907651153",
      de: "907608303",
      fr: "912228805",
      it: "927421022"
    },
    7: {
      en: "907651180",
      de: "907608346",
      fr: "912228873",
      it: "927421053"
    },
    8: {
      en: "907651215",
      de: "907608393",
      fr: "912228972",
      it: "927421094"
    },
    9: {
      en: "907651263",
      de: "907608430",
      fr: "912229050",
      it: "927421144"
    },
    10: {
      en: "907651292",
      de: "907608495",
      fr: "912229139",
      it: "927421182"
    }
  },
  mft: {
    1: {
      en: "907657305",
      de: "907669115",
      fr: "1000379041",
      it: "927420662"
    },
    2: {
      en: "907657349",
      de: "907669178",
      fr: "1000378983",
      it: "927420742"
    },
    3: {
      en: "907657401",
      de: "907669218",
      fr: "1000378934",
      it: "927420795"
    },
    4: {
      en: "907657448",
      de: "907669010",
      fr: "1000378846",
      it: "927420843"
    },
    5: {
      en: "907657518",
      de: "907669059",
      fr: "913656084",
      it: "927420889"
    },
    6: {
      en: "907657635",
      de: "907669099",
      fr: "913657818",
      it: "927420944"
    }
  },
  mtOnline: {
    1: {
      en: "1157121272",
      de: "1157135851",
      fr: "1157143733",
      it: "927420569"
    },
    2: {
      en: "1157121309",
      de: "1157135915",
      fr: "1157143781",
      it: "927420625"
    },
    3: {
      en: "1157121452",
      de: "1157136045",
      fr: "1157143886",
      it: "927420734"
    },
    4: {
      en: "1157121529",
      de: "1157136112",
      fr: "1157143922",
      it: "927420790"
    },
    5: {
      en: "1157121640",
      de: "1157136275",
      fr: "1157144071",
      it: "927420974"
    },
    6: {
      en: "1157121681",
      de: "1157136339",
      fr: "1157144123",
      it: "927421022"
    },
    7: {
      en: "1157121711",
      de: "1157136383",
      fr: "1157144154",
      it: "927421053"
    },
    8: {
      en: "1157121772",
      de: "1157136441",
      fr: "1157144200",
      it: "927421094"
    },
    9: {
      en: "1157121831",
      de: "1157136478",
      fr: "1157144235",
      it: "927421144"
    },
    10: {
      en: "1157121873",
      de: "1157136532",
      fr: "1157144285",
      it: "927421182"
    }
  },
  mtDemo: {
    1: {
      en: "907651153",
      de: "907608303",
      fr: "912228805",
      it: "927421022"
    },
    2: {
      en: "907651215",
      de: "907608393",
      fr: "912228972",
      it: "927421094"
    }
  },
  mtOnlineDemo: {
    1: {
      en: "907651153",
      de: "907608303",
      fr: "912228805",
      it: "927421022"
    },
    2: {
      en: "907651215",
      de: "907608393",
      fr: "912228972",
      it: "927421094"
    }
  }
};

export const NonPrivateRoutes = [
  "/",
  "/online/pre-ready",
  "/login",
  "/booster",
  "/online",
  "/wait",
  "/booster/wait",
  "/online/wait",
  "/end"
];

export const generateStarPickerStats = (starPositions, starsList) => {
  const temp = [];

  try {
    Object.keys(starPositions).forEach((starType) => {
      const starTypeSelections = starPositions[starType];

      Object.keys(starTypeSelections).forEach((starColumn) => {
        const starColumnSelections = starTypeSelections[starColumn];

        Object.keys(starColumnSelections).forEach((starKey) => {
          const starKeySelections = starColumnSelections[starKey];

          if (starKeySelections?.length > 0 && starType === "a") {
            const existing = temp.find((item) => item.text === starsList[starColumn][starKey]);
            if (existing) {
              existing.value = starKeySelections.length;
              existing.color = "#2ABF5B";
              existing.selectorNames = starKeySelections.map((selection) => selection.name);
            } else
              temp.push({
                text: starsList[starColumn][starKey],
                value: starKeySelections.length,
                color: "#2ABF5B",
                selectorNames: starKeySelections.map((selection) => selection.name)
              });
          }

          if (starKeySelections?.length > 0 && starType === "b") {
            const existing = temp.find((item) => item.text === starsList[starColumn][starKey]);
            if (existing) {
              existing.value2 = starKeySelections.length;
              existing.color2 = "#67AEF4";
              existing.selectorNames2 = starKeySelections.map((selection) => selection.name);
            } else
              temp.push({
                text: starsList[starColumn][starKey],
                value2: starKeySelections.length,
                color2: "#67AEF4",
                selectorNames2: starKeySelections.map((selection) => selection.name)
              });
          }
        });
      });
    });
  } catch (error) {
    console.error("Error in generateStarPickerStats", error);
  } finally {
    return temp;
  }
};
